import * as userInfo from './userInfo';

import {combineReducers} from "redux";
import {all, fork} from "redux-saga/effects";

export interface IState  {
    userInfo: userInfo.IState
}

export const ActionCreators = {
    userInfo: userInfo.ActionCreators
}

export const Reducers = combineReducers<IState>({
    userInfo: userInfo.Reducers
});

export function* sagas() {
    yield all([
        fork(userInfo.sagas)
    ]);
}

